import qs from "qs";

const BASE_URL = "https://www.deezer.com/us";

type QueryParams = {
  type?: string;
  id?: string;
};

const useDefaultUrl = () => {
  if (typeof window === "undefined") {
    return `${BASE_URL}/playlist/1479458365`;
  }
  const url = window.location.search;

  const { type = "playlist", id = "1479458365" }: QueryParams = qs.parse(url, {
    ignoreQueryPrefix: true,
  });

  return `${BASE_URL}/${type}/${id}`;
};

export default useDefaultUrl;
